import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLanguage } from '../../context/LanguageContext';
import { CONTACT_PHONE_WHATSAPP } from '../../constants/contact';
import './ThankYou.css';

const ThankYou: React.FC = () => {
  const { t } = useLanguage();

  const homeHref = '/';
  const whatsappHref = `https://wa.me/${CONTACT_PHONE_WHATSAPP}`;

  return (
    <div className="thank-you-page">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8}>
            <div className="thank-you-shell">
              <div className="thank-you-card">
                <div className="thank-you-badge">✓</div>
                <h1 className="thank-you-title">{t('thankyou.title')}</h1>
                <p className="thank-you-subtitle">{t('thankyou.subtitle')}</p>
                <p className="thank-you-description">{t('thankyou.description')}</p>

                <div className="thank-you-actions">
                  <a href={homeHref} className="thank-you-btn thank-you-btn-primary">
                    {t('thankyou.goHome')}
                  </a>
                  <a
                    href={whatsappHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="thank-you-btn thank-you-btn-secondary"
                  >
                    {t('thankyou.whatsapp')}
                  </a>
                </div>
              </div>

              <div className="thank-you-footer">
                {t('thankyou.additionalInfo')}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ThankYou;
